import React from 'react';
import './SprichwortSecondHalf.css';

const SprichwortSecondHalf = ({ text }) => {
  return (
    <div className="sprichwort-second-half">
      <span className="sprichwort-text">{text}</span>
    </div>
  );
};

export default SprichwortSecondHalf;

